import { render, staticRenderFns } from "./PostSummaryCard.vue?vue&type=template&id=988955b8"
import script from "./PostSummaryCard.vue?vue&type=script&lang=js"
export * from "./PostSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports